<!-- 页面布局-公共底部 -->
<template>
  <div
    class="page-footer"
    :class="environmentData.country == 'cn' ? 'footer-height-cn' : ''">
    <div class="footers">
      <div class="footer-cn" v-if="environmentData.country == 'cn'">
        <div class="footer-url">
          <a :href="icpUrl" target="_blank">京ICP备17025273号-4</a>
          <a :href="recorderUrl" target="_blank"> 京公网安备11010802032458 </a>
        </div>
      </div>
      <div class="copy-right" v-else>
        COPYRIGHT © SEGWAY INC. ALL RIGHTS RESERVED.
      </div>
      <div
        class="country"
        @click="toInternational"
        v-if="country && lang && isSelectCountry">
        <svg-icon name="icon-country" class="ic-country" />
        <div class="text">{{ country }} / {{ lang }}</div>
      </div>
    </div>
    <div class="footer-bottom" v-if="environmentData.country == 'cn'">
      <span>Copyright © 2024 ninebot.com</span>
      <span>纳恩博(北京)科技有限公司 版权所有</span>
    </div>
  </div>
</template>
<script setup lang="ts">
import { getAsyncData, environmentData } from '@support/utils';
import { getSiteMapList } from '@support/api';
import { useUrl } from '@support/json';

defineProps({
  isSelectCountry: {
    default: true,
    type: Boolean
  }
});
const { $sensorTrack } = useNuxtApp();
const { icpUrl, recorderUrl } = useUrl();

const router = useRouter();

let country = ref();
let lang = ref();
let countryList = ref([]);

onMounted(() => {
  getCountryData();
});

async function getCountryData() {
  try {
    await nextTick();
    const { data } = await useAsyncData(() => getSiteMapList());
    countryList.value = getAsyncData(data).data;
    const countryId = localStorage.getItem('countryId');
    for (let i = 0; i < countryList.value.length; i++) {
      const countries = countryList.value[i].countries;
      // 判断美洲站点
      if (
        environmentData.country == 'us' &&
        countryList.value[i].name == 'America'
      ) {
        // 获取美洲站点
        const countryArr = countries.filter(
          (item: any) => item.country == environmentData.country
        );
        // 判断点击美洲站点的countryId是否存在，存在即跳转到对应站点，不存在跳转到默认美国站点
        if (countryId) {
          for (let m = 0; m < countryArr.length; m++) {
            if (countryArr[m].id == countryId) {
              country.value = countryArr[m].countryName;
              lang.value = countryArr[m].langName;
            }
          }
        } else {
          country.value = countryArr[0].countryName;
          lang.value = countryArr[0].langName;
        }
      } else {
        // 判断其他站点，当前国家语言匹配到，则跳转到对应站点
        for (let j = 0; j < countries.length; j++) {
          if (
            countries[j].country == environmentData.country &&
            countries[j].language == environmentData.lang
          ) {
            country.value = countries[j].countryName;
            lang.value = countries[j].langName;
          }
        }
      }
    }
  } catch (error: any) {
    error?.msg && showToast(error.msg);
  }
}

function toInternational() {
  $sensorTrack('change_language_click');
  router.push({
    path: '/international'
  });
}

function toIcpUrl(url: string) {
  useWindowsOpen(url);
}
</script>
<style lang="scss" scoped>
.page-footer {
  flex-shrink: 0;
  height: 80px;
  background: #1d2226;
  .copy-right {
    font-size: 16px;
    // font-family: SF Pro Display-Regular, SF Pro Display;
    color: #ffffff;
  }
}
.footer-height-cn {
  height: 118px;
}
.footers {
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 22px;
}
.footer-cn {
  width: 717px;
  justify-content: center;
  font-size: 13px;
  .footer-url {
    a {
      font-size: 16px;
      color: #ffffff;
      text-decoration: none;
      margin-right: 24px;
      cursor: pointer;
    }
  }
}
.country {
  height: 36px;
  display: flex;
  align-items: center;
  font-size: 16px;
  border-radius: 4px;
  color: #ffffff;
  cursor: pointer;
  padding: 0 8px;
  .ic-country {
    width: 24px;
    height: 24px;
    margin-right: 4px;
  }
  &:hover {
    background: rgba(255, 255, 255, 0.15);
  }
}
.footer-bottom {
  width: 1200px;
  margin: auto;
  margin-top: 12px;
  span {
    font-size: 14px;
    color: #ffffff;
    opacity: 0.4;
    margin-right: 20px;
  }
}
</style>
